import React from 'react';
import Seo from '../../components/Seo';
import { getStaticMeta } from '../../seo/pageMeta';

const DisclosureScreen = () => {
  const meta = getStaticMeta('disclosure', 'en');

  return (
    <div className="min-h-screen bg-bg pt-28 pb-24 text-body md:pt-32">
      <Seo title={meta.title} description={meta.description} path="/disclosure" />
      <div className="mx-auto max-w-page px-6">
        <article className="max-w-3xl mx-auto prose prose-invert prose-headings:text-body prose-a:text-primary prose-p:text-muted prose-li:text-muted">
          <h1>Disclosure</h1>

          <section>
            <h2>1. Risk Disclaimer</h2>
            <p>
              Trading financial instruments, including futures, forex, stocks, and cryptocurrencies, carries a high level of risk and may not be suitable for all investors. Leverage can work for or against you. You may lose more than your initial investment. Before deciding to trade, you should carefully consider your investment objectives, level of experience, and risk appetite.
            </p>
            <p>Past performance is not indicative of future results.</p>
            <p>
              All examples, strategies, and tools are for educational and informational purposes only. Nothing on this website or any associated content should be considered financial or investment advice.
            </p>
          </section>

          <section>
            <h2>2. Educational Purpose Only</h2>
            <p>
              All materials offered by Hameral — including indicators, PDFs, trading strategies, mindset content, and social media posts — are designed for educational use. We do not offer personalized trading advice or recommend specific trades or investments.
            </p>
          </section>

          <section>
            <h2>3. No Guarantees</h2>
            <p>
              We do not guarantee any specific outcome, profit, or result from the use of our products or strategies. Words such as "consistency," "edge," "improvement," or "strategy" refer to theoretical and educational frameworks, not promises of success.
            </p>
          </section>

          <section>
            <h2>4. Affiliate Disclosure</h2>
            <p>
              Hameral may participate in affiliate marketing programs. This means that we may earn a commission if you click on a link or make a purchase through our recommended brokers, platforms, or services — at no additional cost to you. We only promote tools and services we believe provide value to traders.
            </p>
          </section>

          <section>
            <h2>6. Use at Your Own Risk</h2>
            <p>
              By accessing this website and using our tools, content, or downloads, you acknowledge that you are acting at your own risk and understand the nature of speculative trading. You agree not to hold Hameral, its team, or partners liable for any losses or damages incurred.
            </p>
            <p>
              If you have any questions about this disclosure, please contact us at support@hameral.com.
            </p>
          </section>

          <section>
            <h2>7. Hypothetical Performance Disclosure</h2>
            <p>
              Hypothetical performance results have many inherent limitations, some of which are described below. No representation is being made that any account will or is likely to achieve profits or losses similar to those shown; in fact, there are frequently sharp differences between hypothetical performance results and the actual results subsequently achieved by any particular trading program. One of the limitations of hypothetical performance results is that they are generally prepared with the benefit of hindsight. In addition, hypothetical trading does not involve financial risk, and no hypothetical trading record can completely account for the impact of financial risk of actual trading. For example, the ability to withstand losses or to adhere to a particular trading program in spite of trading losses are material points which can also adversely affect actual trading results. There are numerous other factors related to the markets in general or to the implementation of any specific trading program which cannot be fully accounted for in the preparation of hypothetical performance results and all which can adversely affect trading results.
            </p>
          </section>

          <section>
            <h2>8. Testimonials</h2>
            <p>
              Testimonials appearing on this website may not be representative of other clients or customers and is not a guarantee of future performance or success.
            </p>
          </section>

          <section>
            <h2>9. Live Trade Room or Trade Examples/ Ideas</h2>
            <p>
              This presentation is for educational purposes only and the opinions expressed are those of the presenter only. All trades presented should be considered hypothetical and should not be expected to be replicated in a live trading account.
            </p>
          </section>
        </article>
      </div>
    </div>
  );
};

export default DisclosureScreen;
